import { PartnerScore, PartnerScoreBucket } from '@/types/partners';
import { ReportPartnerImpactScore } from '@/types/reports';

export const MAX_PARTNER_TAGS = 200;
export const PARTNERBASE_BASE_URL = 'https://www.partnerbase.com';
export const FIND_PARTNERS_LINK = `${PARTNERBASE_BASE_URL}/app/search/?partnerTechStack=Crossbeam&sort=partner_count`;

export const PARTNER_SCORES = {
  EXCELLENT: 'excellent',
  STRONG: 'strong',
  HIGH: 'high',
  MODERATE: 'moderate',
  MEDIUM: 'medium',
  LOW: 'low',
  WEAK: 'weak',
  MINIMAL: 'minimal',
  NONE: 'none',
  UNKNOWN: 'unknown',
} as const;

export const RELEVANT_IMPACTS: ReportPartnerImpactScore[] = [
  PARTNER_SCORES.HIGH,
  PARTNER_SCORES.MEDIUM,
];

export const IMPACT_COLORS = {
  high: 'text-success-accent',
  medium: 'text-warning-accent',
  low: 'text-accent-accent',
} as const satisfies Partial<Record<ReportPartnerImpactScore, string>>;

export const PARTNER_SCORE_COLORS = {
  high: 'success',
  medium: 'warning',
  low: 'accent',
  none: 'neutral',
  unknown: 'neutral',
} as const satisfies Record<NonNullable<PartnerScoreBucket>, string>;

export const IMPACT_SCORE_WEIGHT_LOOKUP: Record<
  ReportPartnerImpactScore,
  number
> = {
  high: 4,
  medium: 3,
  low: 2,
  none: 1,
  unknown: 0,
};

export const PARTNER_SCORE_WEIGHT_LOOKUP: Record<
  NonNullable<PartnerScore>,
  number
> = {
  excellent: 6,
  strong: 5,
  moderate: 4,
  weak: 3,
  minimal: 2,
  none: 1,
  unknown: 0,
};

export const PARTNER_GRADIENTS = {
  high: 'bg-linear-to-r text-success-text from-success-background-weak to-success-background-weak/20',
  medium:
    'bg-linear-to-r text-warning-text from-warning-background-weak to-warning-background-weak/20',
  low: 'bg-linear-to-r text-accent-text from-accent-background-weak to-accent-background-weak/20',
  none: 'bg-linear-to-r text-neutral-text from-neutral-background-weak to-neutral-background-weak/20',
  unknown:
    'bg-linear-to-r text-neutral-text from-neutral-background-weak to-neutral-background-weak/20',
} as const satisfies Partial<Record<ReportPartnerImpactScore, string>>;
